export const isRoleSuperAdmin = (roleId) => {
  return JSON.parse(process.env.REACT_APP_SUPERADMIN_ROLE_ACCESS ?? 0) === roleId ? true : false
}
export const isRoleCompany = (roleId) => {
  return JSON.parse(process.env.REACT_APP_COMPANY_ROLE_ACCESS ?? 0) === roleId ? true : false
}
export const isRoleCostumer = (roleId) => {
  return JSON.parse(process.env.REACT_APP_COSTUMER_ROLE_ACCESS ?? 0) === roleId ? true : false
}
